import { size } from "lodash";

export function getStringLength(chars: string = "") {
  return size([...chars])
}
